// Permisos del circuito de compras (tabla `Permiso` del backend).
// La autorización efectiva la aplica siempre el backend (API/src/helpers/compraAccess.js).
export const PERMISOS_COMPRAS = {
  // Pantalla "Pedidos": permite iniciar una solicitud de compra desde la sucursal.
  SOLICITAR_DESDE_PEDIDOS: 36,
  // Acceso al módulo y solicitudes; las acciones de gestión tienen permisos propios.
  ADMINISTRAR_EXPEDIENTES: 37,
  // Pantalla "Compras": permite iniciar una solicitud de compra desde el módulo de compras.
  SOLICITAR_DESDE_COMPRAS: 38,
  // Pantalla "Compras": editar el pliego particular desde el tab Estados (solo en pantalla).
  EDITAR_PLIEGO_PARTICULAR: 46,
  GESTIONAR_COTIZACION: 73,
  VER_OFERTAS: 74,
  VER_RANKING: 75,
  PREADJUDICAR: 76,
  GENERAR_ORDENES: 77,
  CREAR_ORDEN_DIRECTA: 78,
  ANULAR_ORDEN: 79,
  PRORROGAR_ORDEN: 80,
  ACTUALIZAR_PRESUPUESTO_ORDEN: 81,
  ENVIAR_ORDEN: 82,
  ANULAR_REACTIVAR_PEDIDO: 83,
  EDITAR_PEDIDOS_AJENOS: 84,
  OPERAR_PASOS_COMPRAS: 85,
  VER_PROVEEDORES_PEDIDO: 86,
};

// Quién puede crear una solicitud, sin importar desde qué pantalla la inicia.
export const PERMISOS_CREAR_SOLICITUD = [
  PERMISOS_COMPRAS.SOLICITAR_DESDE_PEDIDOS,
  PERMISOS_COMPRAS.ADMINISTRAR_EXPEDIENTES,
  PERMISOS_COMPRAS.SOLICITAR_DESDE_COMPRAS,
];

// Quién ve las acciones de solicitud dentro de la pantalla "Compras".
export const PERMISOS_SOLICITAR_EN_COMPRAS = [
  PERMISOS_COMPRAS.ADMINISTRAR_EXPEDIENTES,
  PERMISOS_COMPRAS.SOLICITAR_DESDE_COMPRAS,
];

const esAdministrador = (user) => user?.tipoUser === "Administrador";

const DEPENDENCIAS_COMPRAS = {
  [PERMISOS_COMPRAS.VER_RANKING]: [PERMISOS_COMPRAS.VER_OFERTAS],
  [PERMISOS_COMPRAS.PREADJUDICAR]: [PERMISOS_COMPRAS.VER_OFERTAS],
  [PERMISOS_COMPRAS.GENERAR_ORDENES]: [PERMISOS_COMPRAS.VER_OFERTAS],
  // Sin las ofertas la pantalla no puede evaluar los requisitos del paso ni los renglones desiertos.
  [PERMISOS_COMPRAS.CREAR_ORDEN_DIRECTA]: [PERMISOS_COMPRAS.VER_OFERTAS],
  [PERMISOS_COMPRAS.OPERAR_PASOS_COMPRAS]: [PERMISOS_COMPRAS.VER_OFERTAS],
};

export const tienePermisoCompras = (user, verificarAcceso, permiso) =>
  esAdministrador(user) ||
  (user?.tipoUser === "Empleado" &&
    verificarAcceso([permiso, ...(DEPENDENCIAS_COMPRAS[permiso] || [])]));

// Modo de presentación. Cada botón aplica además su permiso específico.
export const esGestorCompras = (user, verificarAcceso) =>
  Object.values(PERMISOS_COMPRAS).filter((id) => id >= 73 && id <= 86)
    .some((id) => tienePermisoCompras(user, verificarAcceso, id));

/**
 * Quién opera un paso del circuito según su área (igual que el backend):
 * Solicitante → quien creó el pedido; Compras → el gestor; otras áreas → solo Administrador.
 */
export const puedeOperarAreaPaso = (area, { user, verificarAcceso, idCreador }) => {
  if (esAdministrador(user)) return true;
  if (user?.tipoUser !== "Empleado") return false;
  if (area === "Solicitante") return idCreador != null && user?.id == idCreador;
  if (area === "Compras") return tienePermisoCompras(user, verificarAcceso, PERMISOS_COMPRAS.OPERAR_PASOS_COMPRAS);
  return false;
};
